(function() { window.GUID_88ff0f6d_fc08_42ac_9d8c_1830db0fd1c9 = { getGuid: function() { return "88ff0f6d-fc08-42ac-9d8c-1830db0fd1c9"; } }; })();
var CS;
(function (CS) {
    /** This class is only to have a common point between Views and Controls */
    class CSInstanceBase {
        constructor() {
            this.uniqueInstanceId = CS.Controls.GetNewInstanceId();
        }
        get UniqueInstanceId() {
            return this.uniqueInstanceId;
        }
    }
    CS.CSInstanceBase = CSInstanceBase;
})(CS || (CS = {}));

//# sourceMappingURL=cs-instance-base.js.map
